
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/capabilities",
      function () {
        return require("private-next-pages/capabilities.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/capabilities"])
      });
    }
  